declare var require: any;
var mixpanelModule = require('mixpanel-browser');
var mixpanel = mixpanelModule.default || mixpanelModule;
import UserService from '../user/user.service';

// ---------------------------------------------------------------------------
// Session Replay — Privacy Configuration
// ---------------------------------------------------------------------------
const REPLAY_MASK_TEXT_SELECTOR = '[data-pii]';
const REPLAY_BLOCK_SELECTOR = '[data-block-replay]';

/* @ngInject */
export default class MixpanelService {

  private isInitialized = false;
  private isIdentified = false;

  constructor(
    private config,
    private userService: UserService
  ) {}

  public init(): void {
    if (this.isInitialized) {
      return;
    }

    const token = this.config.mixpanelToken;
    if (!token) {
      return;
    }

    mixpanel.init(token, {
      debug: this.config.environment !== 'prod' && this.config.environment !== 'gprd',
      track_pageview: false,
      persistence: 'localStorage',
      // Session Replay
      record_sessions_percent: 100, // Örnek olarak %100 oranında oturum kaydedilecek şekilde ayarlanmıştır. İhtiyaca göre bu oran artırılabilir veya azaltılabilir.
      record_mask_all_text: false,
      record_mask_text_selector: REPLAY_MASK_TEXT_SELECTOR,
      record_mask_all_inputs: true,
      record_block_selector: REPLAY_BLOCK_SELECTOR,
      remote_settings_mode: 'fallback',
      autocapture: {
        pageview: false,
        click: false,
        dead_click: true,
        input: false,
        rage_click: true,
        scroll: false,
        submit: false,
        capture_text_content: false,
      },
      record_heatmap_data: true,
    });

    mixpanel.register({
      client: 'web'
    });

    this.isInitialized = true;
    this.identify();
  }

  public identify(): void {
    if (!this.isInitialized || this.isIdentified) {
      return;
    }

    this.userService.getUserInfo().then(userInfo => {
      if (userInfo && userInfo.id) {
        mixpanel.identify(String(userInfo.id));
        this.isIdentified = true;
      }
    });
  }

  public track(eventName: string, properties: Object = {}): void {
    if (!this.isInitialized) {
      return;
    }

    mixpanel.track(eventName, properties);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/analytics/mixpanel.service.ts